export function markSelectBoxValue(elementId: string, optionId: string) {
    let elements = document.getElementById(elementId);

    for (var i = 0; i < elements.length; i++) {
        if (elements.options[i].value == optionId) {
            elements.options[i].selected = true;
        }
    }
}
